const getCompany = (state) => {
  return state?.company?.data || {};
};

const getIsCompanyLoading = (state) => {
  return state?.company?.loading;
};

export { getCompany, getIsCompanyLoading };
